import React from 'react';
import CategoryList from './category-list';

const Category = () => <CategoryList />;

export default Category;
